'use strict';
{
    var app = angular.module('tf.support', [])
        .controller('supportCtrl', ['$scope', '$state',  '$resource', 'uiGridConstants', 'uiGridExporterConstants', '$http', 'csv', '$sanitize', '$filter', function supportController($scope, $state, $resource, uiGridConstants, uiGridExporterConstants, $http, csv, $sanitize, $filter) {


            $scope.view = 'portfolio';


            $scope.$scope = $scope;


            $scope.exportCsv = function(){
                $scope.gridApi.exporter.csvExport( uiGridExporterConstants.ALL, uiGridExporterConstants.ALL);
            };

            $scope.exportCsvVisible = function(){
                $scope.gridApi.exporter.csvExport( uiGridExporterConstants.VISIBLE, uiGridExporterConstants.VISIBLE);
            };

            $scope.gridOptionsSupport = {
                flatEntityAccess : true,
                enableGridMenu: true,
                enableColumnResizing: true,
                enableFiltering: true,
                minRowsToShow : 15,
                enablePaging : false,
                showFooter: true,
                showColumnFooter: true,
                excessRows : 20,
                enableHorizontalScrollbar : uiGridConstants.scrollbars.NEVER,
                exporterCsvFilename: 'marginComparison.csv',
                columnDefs: [
                    {name : 'accountNumber',
                        type : 'string',
                        displayName: 'Account Number', width : '*', cellTemplate : '<div class="ngCellText ui-grid-cell-contents colt{{$index}}"><a href="#/portfolio/{{row.entity.portfolioId}}">{{ row.entity[\'accountNumber\'] }}</a></div>',
                        filter: {
                            condition: uiGridConstants.filter.CONTAINS
                        }
                    },
                    {
                        name: 'accountName',
                        type : 'string',
                        displayName: 'Account Name',
                        width: '*',
                        cellTemplate: '<div class="ngCellText ui-grid-cell-contents colt{{$index}}"><a target="_blank" href="#/portfolio/{{row.entity.portfolioId}}">{{ row.entity[\'accountName\'] }}</a></div>',
                        filter: {
                            condition: uiGridConstants.filter.CONTAINS
                        }
                    },
                    { name: 'adviser',
                        type : 'string',
                        displayName : 'Org & Adviser', width: '*'},
                    { name: 'asxMargin',
                        type : 'number',
                        displayName: 'ASX Margin', width: '**', headerCellClass: 'gridNumber', cellClass: 'gridNumber', cellFilter : 'number:2'},
                    { name: 'tfMargin', type : 'number',
                        displayName: 'TF Margin', width: '**', headerCellClass: 'gridNumber', cellClass: 'gridNumber', cellFilter : 'number:2'},
                    { name: 'diffMargin',
                        type : 'number',
                        displayName: 'Diff Margin', width: '**', headerCellClass: 'gridNumber', cellClass: 'gridNumber',
                        cellFilter : 'number:2', footerCellFilter : 'number: 2',
                        footerCellClass : 'gridNumber',
                        cellTemplate : '<div class="ngCellText ui-grid-cell-contents colt{{$index}}"><a target="_blank" ng-click="grid.appScope.showPositions(row.entity)">{{ row.entity.diffMargin | number:2}}</a></div>',
                        aggregationType: uiGridConstants.aggregationTypes.sum, aggregationHideLabel: true},
                    { name: 'asxScanRisk',
                        type : 'number',
                        displayName: 'ASX Scan Risk', width: '**', headerCellClass: 'gridNumber', cellClass: 'gridNumber', cellFilter : 'number:2'},
                    { name: 'tfScanRisk', type : 'number',
                        displayName: 'TF Scan Risk', width: '**', headerCellClass: 'gridNumber', cellClass: 'gridNumber', cellFilter : 'number:2'},
                    { name: 'diffScanRisk',
                        type : 'number',
                        displayName: 'Diff Scan Risk', width: '**',
                        visible : false,
                        headerCellClass: 'gridNumber',
                        cellClass: 'gridNumber',
                        footerCellClass : 'gridNumber',
                        cellFilter : 'number:2',
                        footerCellFilter : 'number: 2',
                        aggregationType: uiGridConstants.aggregationTypes.sum, aggregationHideLabel: true,
                        cellTemplate : '<div class="ngCellText ui-grid-cell-contents colt{{$index}}"><a target="_blank" ng-click="grid.appScope.showPositions(row.entity)">{{ row.entity.diffScanRisk | number:2}}</a></div>'
                    },
                    { name: 'asxPremiumMargin',
                        type : 'number',
                        displayName: 'ASX Premium', width: '**', headerCellClass: 'gridNumber', cellClass: 'gridNumber', cellFilter : 'number:2'},
                    { name: 'tfPremiumMargin',
                        type : 'number',
                        displayName: 'TF Premium', width: '**', headerCellClass: 'gridNumber', cellClass: 'gridNumber', cellFilter : 'number:2'},
                    {
                        name: 'diffPremiumMargin',
                        type : 'number',
                        displayName: 'Diff Premium',
                        width: '**',
                        visible : false,
                        headerCellClass: 'gridNumber',
                        cellClass: 'gridNumber',
                        footerCellClass : 'gridNumber',
                        cellFilter: 'number:2',
                        footerCellFilter : 'number: 2',
                        aggregationType: uiGridConstants.aggregationTypes.sum,
                        aggregationHideLabel: true
                    },
                    { name: 'asxIc',
                        type : 'number',
                        displayName: 'ASX I/C', width: '**', headerCellClass: 'gridNumber', cellClass: 'gridNumber', cellFilter : 'number:2'},
                    { name: 'tfIc',
                        type : 'number',
                        displayName: 'TF I/C', width: '**', headerCellClass: 'gridNumber', cellClass: 'gridNumber', cellFilter : 'number:2'},
                    { name: 'diffIc',
                        type : 'number',
                        displayName: 'Diff I/C', width: '**',
                        visible : false,
                        headerCellClass: 'gridNumber', cellClass: 'gridNumber',
                        cellFilter : 'number:2', footerCellFilter : 'number: 2',
                        footerCellClass : 'gridNumber',
                        aggregationType: uiGridConstants.aggregationTypes.sum, aggregationHideLabel: true}

                ],
                onRegisterApi: function(gridApi){
                    $scope.gridApi = gridApi;
                },

                data: []
            };

            $http.get('/tradefloor/api/support/portfolios.csv').then(function(response) {
                $scope.gridOptionsSupport.data = csv.parse(response.data, function (row, rowNumber) {
                    if (rowNumber == 0) {
                        return null;
                    }
                    return {
                        portfolioId : row[0],
                        accountNumber : row[1],
                        accountName : row[2],
                        adviser : row[3],
                        asxScanRisk : +row[4],
                        tfScanRisk : +row[5],
                        diffScanRisk : +row[6],
                        asxPremiumMargin : +row[7],
                        tfPremiumMargin : +row[8],
                        diffPremiumMargin : +row[9],
                        asxIc : +row[10],
                        tfIc : +row[11],
                        diffIc : +row[12],
                        asxMargin : +row[13],
                        tfMargin : +row[14],
                        diffMargin : +row[15]
                    };
                });


                $scope.gridOptionsSupport.data.sort(function (a, b){
                    var aDiff = Math.max(a.diffScanRisk, a.diffPremiumMargin);
                    var bDiff = Math.max(b.diffScanRisk, b.diffPremiumMargin);

                    if (aDiff > bDiff) {
                        return -1;
                    } else if (aDiff < bDiff) {
                        return 1;
                    }

                    return 0;
                });
            });

            $scope.marginComparisonPositions = {
                enableGridMenu: true,
                enableColumnResizing: true,
                enableFiltering: true,
                minRowsToShow : 15,
                enablePaging : false,
                showFooter: true,
                excessRows : 20,
                enableHorizontalScrollbar : uiGridConstants.scrollbars.NEVER,
                columnDefs: [
                    { name: 'code',
                        type : 'string',
                        displayName : 'ASX Code', width: '*',
                        cellTemplate : '<div class="ngCellText ui-grid-cell-contents colt{{$index}}"><a ng-click="grid.appScope.get(row.entity.code)">{{ row.entity.code }}</a></div>'
                    },
                    { name: 'quantity',
                        type : 'number', displayName : 'Quantity', width: '*', headerCellClass: 'gridNumber', cellClass: 'gridNumber', cellFilter : 'number:0'},
                    { name: 'asxScanRisk', type : 'number', displayName: 'ASX Scan', width: '**', headerCellClass: 'gridNumber', cellClass: 'gridNumber', cellFilter : 'number:2'},
                    { name: 'tfScanRisk', type : 'number', displayName: 'TF Scan', width: '**', headerCellClass: 'gridNumber', cellClass: 'gridNumber', cellFilter : 'number:2'},
                    { name: 'diffScanRisk', type : 'number', aggregationType: uiGridConstants.aggregationTypes.sum, aggregationHideLabel: true, displayName: 'Diff Scan Risk', width: '**', headerCellClass: 'gridNumber', cellClass: 'gridNumber', cellFilter : 'number:2'},
                    { name: 'asxPremiumMargin', type : 'number', displayName: 'ASX Premium', width: '**', headerCellClass: 'gridNumber', cellClass: 'gridNumber', cellFilter : 'number:2'},
                    { name: 'tfPremiumMargin', type : 'number', displayName: 'TF Premium', width: '**', headerCellClass: 'gridNumber', cellClass: 'gridNumber', cellFilter : 'number:2'},
                    { name: 'diffPremiumMargin', type : 'number', displayName: 'Diff Premium', width: '**', headerCellClass: 'gridNumber', cellClass: 'gridNumber', cellFilter : 'number:2'},
                    { name: 'asxSpanDelta', type : 'number', displayName: 'ASX SPAN Delta', width: '**', headerCellClass: 'gridNumber', cellClass: 'gridNumber', cellFilter : 'number:4'},
                    { name: 'tfSpanDelta', type : 'number', displayName: 'TF SPAN Delta', width: '**', headerCellClass: 'gridNumber', cellClass: 'gridNumber', cellFilter : 'number:4'},
                    { name: 'diffSpanDelta', type : 'number', displayName: 'Diff SPAN Delta', width: '**', headerCellClass: 'gridNumber', cellClass: 'gridNumber', cellFilter : 'number:4'}
                ],
                data: []
            };


            $scope.showSummary = function() {
                $scope.view = 'portfolio';
                $scope.currentAccount = undefined;
            };

            $scope.showPositions = function (row, cc) {
                $scope.currentAccount = row;
                $http.get('/tradefloor/api/support/portfolio/' + row.portfolioId + '/positions' + (cc ? '?cc=' + cc : '')).then(function (response) {

                    $scope.marginComparisonPositions.data = csv.parse(response.data, function (row, rowNumber) {
                        if (rowNumber == 0) {
                            return null;
                        }
                        return {
                            code: row[0],
                            quantity: +row[1],
                            asxScanRisk: +row[2],
                            tfScanRisk: +row[3],
                            diffScanRisk: +row[4],
                            asxPremiumMargin: +row[5],
                            tfPremiumMargin: +row[6],
                            diffPremiumMargin: +row[7],
                            asxSpanDelta: +row[8],
                            tfSpanDelta: +row[9],
                            diffSpanDelta: +row[10]

                        };
                    });

                    $scope.marginComparisonPositions.data.sort(function (a, b){

                        if (a.diffScanRisk > b.diffScanRisk) {
                            return -1;
                        } else if (a.diffScanRisk < b.diffScanRisk) {
                            return 1;
                        }

                        return 0;
                    });

                    $scope.view = 'position';

                });
            };

            $scope.updateFilterTerm = function(col) {
                if (col.dateTerm) {
                    col.term = $filter('date')(col.dateTerm, 'yyyy-MM');
                } else {
                    col.term = '';
                }
            };


            $scope.optionValuation = {
                flatEntityAccess : true,
                enableGridMenu: true,
                enableColumnResizing: true,
                enableFiltering: true,
                minRowsToShow : 15,
                enablePaging : false,
                excessRows : 20,
                enableHorizontalScrollbar : uiGridConstants.scrollbars.NEVER,
                columnDefs: [
                    { name: 'code', type : 'string', displayName : 'ASX Code', width: '*',
                        cellTemplate : '<div class="ngCellText ui-grid-cell-contents colt{{$index}}"><a ng-click="grid.appScope.requestOptionParams(row.entity.code)">{{ row.entity.code }}</a></div>'
                    },
                    { name: 'id', type : 'number', displayName: 'SPAN ID', width: '*'},
                    { name: 'product', type : 'string', displayName: 'Product', width: '*', cellFilter : 'product'},
                    { name: 'type', type : 'string',  displayName: 'Type', width: '*', cellTemplate: '<div class="ui-grid-cell-contents"><span style="width:3ch; display: inline-block">{{row.entity.type | type}}</span><span ng-if="row.entity.style != \'FUTURE\'">&nbsp;&ndash;&nbsp;{{row.entity.style | style}}</span></div>'},
                    { name: 'expiry', type : 'string', displayName: 'Expiry', width: '**', headerCellClass: 'date',
                        cellTemplate: '<div class="ui-grid-cell-contents">{{row.entity.expiry | date:\'MMM yy\'}}</div>',
                        filterHeaderTemplate: '<div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters"><div class="input-group"><input readonly type="text" class="ui-grid-filter-input" uib-datepicker-popup="MMM yy" datepicker-append-to-body="true" ng-model="colFilter.dateTerm" ng-change="grid.appScope.updateFilterTerm(colFilter)" is-open="colFilter.isOpen" ng-click="colFilter.isOpen = true" show-button-bar="false" ng-init="colFilter.mode = \'month\'" datepicker-mode="colFilter.mode" datepicker-options="{formatMonth : \'MMM\', yearRange : 5, maxMode : \'month\', minMode : \'month\'}" /><div class="ui-grid-filter-button ng-scope" ng-click="colFilter.term = null;colFilter.dateTerm = null" ng-if="!colFilter.disableCancelFilterButton"><i class="ui-grid-icon-cancel" ng-show="colFilter.term !== undefined && colFilter.term != null">&nbsp;</i></div></div></div>',
                        filterable: true,
                        filters: [{
                            flags: {
                                date: true
                            },
                            condition: uiGridConstants.filter.STARTS_WITH
                        }] },
                    { name: 'strike', type : 'number', displayName: 'Strike', width: '**', headerCellClass: 'gridNumber', cellClass: 'gridNumber', cellFilter : 'number:3'},
                    { name: 'underlyingPrice', type : 'number', displayName: 'Underlying Price', width: '**', headerCellClass: 'gridNumber', cellClass: 'gridNumber', cellFilter : 'number:3'},
                    { name: 't', type : 'number', displayName: 'Time to Expiry', width: '**', headerCellClass: 'gridNumber', cellClass: 'gridNumber', cellFilter : 'number:4'},
                    { name: 'lastDiv', type : 'number', displayName: 'Last Div', width: '**', headerCellClass: 'gridNumber', cellClass: 'gridNumber', cellFilter : 'number:4'},
                    { name: 'r', type : 'number', displayName: 'RFR', width: '**', headerCellClass: 'gridNumber', cellClass: 'gridNumber', cellFilter : 'percentage:2'},
                    { name: 'v', type : 'number', displayName: 'Vol', width: '**', headerCellClass: 'gridNumber', cellClass: 'gridNumber', cellFilter : 'percentage:2'},
                    { name: 'asxValue', type : 'number', displayName: 'ASX Value', width: '**', headerCellClass: 'gridNumber', cellClass: 'gridNumber', cellFilter : 'number:3'},
                    { name: 'tfValue', type : 'number', displayName: 'TF Value', width: '**', headerCellClass: 'gridNumber', cellClass: 'gridNumber', cellFilter : 'number:3'},
                    { name: 'asxDelta', type : 'number', displayName: 'ASX Delta', width: '**', headerCellClass: 'gridNumber', cellClass: 'gridNumber', cellFilter : 'number:4'},
                    { name: 'tfDelta', type : 'number', displayName: 'TF Delta', width: '**', headerCellClass: 'gridNumber', cellClass: 'gridNumber', cellFilter : 'number:4'}

                ],
                exporterCsvFilename: 'optionValuations.csv',
                data: []
            };

            $http.get('/tradefloor/api/support/options.csv').then(function(response) {
                $scope.optionValuation.data = csv.parse(response.data, function (row, rowNumber) {
                    if (rowNumber == 0) {
                        return null;
                    }
                    return {
                        code : row[0],
                        id : row[1],
                        product : row[2],
                        type : row[3],
                        style : row[4],
                        expiry : row[5],
                        strike : +row[6],
                        underlyingPrice : +row[7],
                        t : +row[8],
                        lastDiv : +row[9],
                        r : +row[10],
                        v : +row[11],
                        asxValue : +row[12],
                        tfValue : +row[13],
                        asxDelta : +row[14],
                        tfDelta : +row[15]
                    };
                });

                $scope.optionValuation.data.sort(function (a, b){
                    var aDiff = Math.abs(a.tfDelta - a.asxDelta);
                    var bDiff = Math.abs(b.tfDelta - b.asxDelta);

                    if (aDiff > bDiff) {
                        return -1;
                    } else if (aDiff < bDiff) {
                        return 1;
                    }

                    return 0;
                });
            });


            $scope.requestOptionParams = function(code) {
                $http.get('/tradefloor/api/support/optionParams/' + code).then(function (response) {
                    $scope.optionParams = {
                        optionCode : response.data.optionCode,
                        underlyingPrice : response.data.underlyingPrice,
                        vol : response.data.vol,
                        rfr : response.data.rfr,
                        psr : response.data.psr,
                        vsr : response.data.vsr,
                        expiry : new Date(response.data.expiry),
                        strike : response.data.strike,
                        dividends : response.data.dividends.map(function (dividend){
                            return {
                                value : dividend.value,
                                settlementDate : new Date(dividend.settlementDate)
                            };

                        } )
                    };
                    $scope.calculateOptionPrice();
                })
            };

            $scope.calculateOptionPrice = function() {
                var optionParams = $scope.optionParams;
                var optionParamsCopy = {
                    optionCode : optionParams.optionCode,
                    underlyingPrice : optionParams.underlyingPrice,
                    vol : optionParams.vol,
                    rfr : optionParams.rfr,
                    psr : optionParams.psr,
                    vsr : optionParams.vsr,
                    expiry : $filter('date')(optionParams.expiry, 'yyyy-MM-dd'),
                    strike : optionParams.strike,
                    dividends : optionParams.dividends.map(function (dividend){
                        return {
                            value : dividend.value,
                            daysToMaturity: (dividend.settlementDate - new Date)/(1000*60*60*24) + 1,
                            settlementDate : $filter('date')(dividend.settlementDate, 'yyyy-MM-dd')
                        };

                    } )
                };
                $http.post('/tradefloor/api/support/calculateOption/crr', optionParamsCopy).then(function (response) {
                    $scope.ra = response.data;
                })
            };

            $scope.recalculateSingleArray = function(r, index) {
                var optionParams = $scope.optionParams;
                var singleRiskArray = {
                    optionCode : optionParams.optionCode,
                    index : index,
                    raUnderlyingPrice: r.underlyingPrice,
                    raVol: r.vol,
                    baseUnderlyingPrice : optionParams.underlyingPrice,
                    baseVol : optionParams.vol,
                    rfr: optionParams.rfr,
                    expiry : $filter('date')(optionParams.expiry, 'yyyy-MM-dd'),
                    strike: optionParams.strike,
                    dividends: optionParams.dividends.map(function (dividend) {
                        return {
                            value: dividend.value,
                            daysToMaturity: (dividend.settlementDate - new Date) / (1000 * 60 * 60 * 24) + 1,
                            settlementDate: $filter('date')(dividend.settlementDate, 'yyyy-MM-dd')
                        };
                    })
                };
                $http.post('/tradefloor/api/support/calculateRiskArray/array', singleRiskArray).then(function (response) {
                    $scope.ra[index].optionPrice = response.data.optionPrice ;
                    $scope.ra[index].tfValue = response.data.riskArrayValue;
                    $scope.ra[index].difference = response.data.difference;
                })
            };

        }])


}